import { type UUID } from '~/types/common';

/**
 * The fixed company-account id of VESTIGAS itself.
 *
 * Internal-user permission management (the "VESTIGAS Admin Rechte" tab on the user
 * detail page) is only offered for users belonging to this account. Mirrors the
 * back-end `vestigas_company_account_id` constant.
 */
export const VESTIGAS_COMPANY_ACCOUNT_ID =
  '0d4eaf9b-e286-4ac6-94c1-eb5daba3422c' as UUID;
